/**
 * Sale Promo System
 * Reads promo config from the sale-promo-config section JSON,
 * determines which promo is active based on current date (Central Time),
 * and renders banners into placeholder slots.
 */
(function() {
  // Get current date parts in Central Time
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  function getTodayCT() {
    const parts = formatter.formatToParts(new Date());
    const get = (type) => parts.find(p => p.type === type).value;
    // Return YYYY-MM-DD string in Central Time
    return `${get('year')}-${get('month')}-${get('day')}`;
  }

  function findActivePromo(promos) {
    const today = getTodayCT();
    for (const promo of promos) {
      if (!promo.startDate || !promo.endDate) continue;
      if (today >= promo.startDate && today <= promo.endDate) {
        return promo;
      }
    }
    return null;
  }

  function buildMessage(promo) {
    let message = promo.message || '';
    if (promo.promoCode) {
      const styledCode = '<strong style="color:' + promo.accentColor + '">' + promo.promoCode + '</strong>';
      message = message.replace('{code}', styledCode);
    }
    return message;
  }

  function renderHeaderBanner(slot, promo, message) {
    var bgStyle = promo.headerBgColor ? 'background-color:' + promo.headerBgColor + ';' : '';
    var fontStyle = promo.headerFontColor ? 'color:' + promo.headerFontColor + ';' : '';
    var disclaimerHtml = promo.headerDisclaimer
      ? '<div class="promoBan__disclaimer" style="' + fontStyle + '">' + promo.headerDisclaimer + '</div>'
      : '';
    slot.innerHTML =
      '<div class="promo__wrapper" style="display:flex;">' +
        '<div class="promoBan__wrapper" style="' + bgStyle + '">' +
          '<div class="promoBan__content">' +
            '<div class="promoBan__text" style="' + fontStyle + '">' + message + '</div>' +
            disclaimerHtml +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderPDPBanner(slot, promo, message) {
    var fontStyle = promo.bannerFontColor ? 'color:' + promo.bannerFontColor + ';' : '';
    slot.innerHTML =
      '<div class="promo__wrapper" style="display:flex;">' +
        '<div class="promoPDP__wrapper" style="background-color:' + promo.bgColor + ';border-color:' + promo.borderColor + ';' + fontStyle + '">' +
          message +
        '</div>' +
      '</div>';
  }

  function renderCartBanner(slot, promo, message) {
    var fontStyle = promo.bannerFontColor ? 'color:' + promo.bannerFontColor + ';' : '';
    slot.innerHTML =
      '<div class="promo__wrapper" style="display:flex;">' +
        '<div class="promoCart__wrapper" style="background-color:' + promo.bgColor + ';border-color:' + promo.borderColor + ';' + fontStyle + '">' +
          '<div class="promoCart__insides">' + message + '</div>' +
        '</div>' +
      '</div>';
  }

  function renderCountdown(headerSlot, promo) {
    if (!promo.showCountdown || !promo.endDate) return;

    // Countdown targets midnight AFTER the end date (i.e., start of the next day)
    // so the timer reaches zero when the sale actually ends at 11:59 PM
    var endDate = new Date(promo.endDate + 'T00:00:00');
    endDate.setDate(endDate.getDate() + 1);
    var year = String(endDate.getFullYear());
    var month = String(endDate.getMonth() + 1).padStart(2, '0');
    var day = String(endDate.getDate()).padStart(2, '0');
    // countdown-timer.js uses DD-MM-YYYY format for data-date
    var countdownDate = day + '-' + month + '-' + year;

    // Build a unique class for this countdown
    var countdownClass = 'sale-promo-countdown-' + promo.id;

    // Create countdown element after the header banner
    var countdownEl = document.createElement('div');
    countdownEl.className = 'countdown ' + countdownClass + ' promo__wrapper';
    countdownEl.setAttribute('data-date', countdownDate);
    countdownEl.setAttribute('data-time', '00:00');
    countdownEl.setAttribute('data-show-days', 'true');
    countdownEl.style.display = 'none';
    countdownEl.innerHTML =
      '<span class="countdownPrompt"><strong>Ends in...</strong></span>' +
      '<div class="countdownText day" style="display:none;"><strong><span class="num"></span> <span class="word"></span></strong></div>' +
      '<div class="countdownText hour"><strong><span class="num"></span> <span class="word"></span></strong></div>' +
      '<div class="countdownText min"><strong><span class="num"></span> <span class="word"></span></strong></div>' +
      '<div class="countdownText sec"><strong><span class="num"></span> <span class="word"></span></strong></div>';

    // Apply countdown colors
    if (promo.countdownBgColor) {
      countdownEl.style.backgroundColor = promo.countdownBgColor;
    } else if (promo.accentColor) {
      countdownEl.style.backgroundColor = promo.accentColor;
    }
    if (promo.countdownFontColor) {
      countdownEl.style.color = promo.countdownFontColor;
      var prompt = countdownEl.querySelector('.countdownPrompt');
      if (prompt) prompt.style.color = promo.countdownFontColor;
      var textEls = countdownEl.querySelectorAll('.countdownText');
      textEls.forEach(function(el) { el.style.color = promo.countdownFontColor; });
    }

    headerSlot.appendChild(countdownEl);

    // Initialize the countdown timer (countdown-timer.js must be loaded)
    if (typeof countdown !== 'undefined') {
      new countdown({
        target: '.' + countdownClass,
        dayWord: 'day',
        hourWord: 'hr',
        minWord: 'min',
        secWord: 'sec',
        showDays: true
      });
      countdownEl.style.display = 'flex';
    }
  }

  function init() {
    var configEl = document.getElementById('sale-promo-config');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var promos = config.promos || [];
    if (!promos.length) return;

    // Warn about overlapping date ranges (helps catch config mistakes)
    var today = getTodayCT();
    var matchingPromos = promos.filter(function(p) {
      return p.startDate && p.endDate && today >= p.startDate && today <= p.endDate;
    });
    if (matchingPromos.length > 1) {
      console.warn('[Sale Promo] Multiple promotions are active for today (' + today + '). Only the first match will display. Check your date ranges in the Sale Promo Config section.');
    }

    // Check for any promo with preview mode enabled first, then fall back to date matching
    var activePromo = promos.find(function(p) { return p.previewMode; }) || findActivePromo(promos);
    if (!activePromo) return;

    var message = buildMessage(activePromo);

    // Render into promo slots based on placement toggles.
    // Free shipping mode replaces the cart banner with a progress bar in the
    // cart drawer header, so skip the standard cart slot in that case.
    var slots = document.querySelectorAll('[data-promo-slot]');
    slots.forEach(function(slot) {
      var location = slot.getAttribute('data-promo-slot');
      if (location === 'header' && activePromo.showHeader !== false) {
        renderHeaderBanner(slot, activePromo, message);
        renderCountdown(slot, activePromo);
      } else if (location === 'PDP' && activePromo.showPdp !== false) {
        renderPDPBanner(slot, activePromo, message);
      } else if (location === 'cart' && activePromo.showCart !== false && !activePromo.freeShippingMode && !activePromo.buyMoreSaveMoreMode) {
        renderCartBanner(slot, activePromo, message);
      }
    });

    // Expose active promo for other scripts (e.g., cart drawer refresh)
    window.__activePromo = activePromo;
    window.__activePromoMessage = message;
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor re-renders a section (live preview without saving)
  document.addEventListener('shopify:section:load', function(event) {
    // Clear existing promo content from all slots so init() can re-render
    var slots = document.querySelectorAll('[data-promo-slot]');
    slots.forEach(function(slot) { slot.innerHTML = ''; });
    init();
  });

  // Expose a refresh function for dynamically inserted slots (e.g., cart drawer)
  window.refreshPromoSlots = function() {
    if (!window.__activePromo) return;
    var promo = window.__activePromo;
    var slots = document.querySelectorAll('[data-promo-slot]');
    slots.forEach(function(slot) {
      // Skip slots that already have content
      if (slot.children.length > 0) return;
      var location = slot.getAttribute('data-promo-slot');
      if (location === 'cart' && promo.showCart !== false && !promo.freeShippingMode && !promo.buyMoreSaveMoreMode) {
        renderCartBanner(slot, promo, window.__activePromoMessage);
      } else if (location === 'PDP' && promo.showPdp !== false) {
        renderPDPBanner(slot, promo, window.__activePromoMessage);
      }
    });
  };
})();
